import loginFormController from './loginForm.controller.js';
/**
 * @ngdoc directive
 * @name loginForm
 * @description Displays a login/reset password form.
 */
export default function loginFormDirective($previousState, $state) {
  'ngInject';

  return {
    restrict: 'E',
    scope: true,
    bindToController: {
      view: '=',
      next: '='
    },
    controller: loginFormController,
    controllerAs: 'login',
    templateUrl: 'app/components/loginForm/loginForm.html',
    link: function ($scope) {
      $scope.close = function () {
        if($previousState.get()) {
          $previousState.go();
        }else{
          $state.go('app');
        }
      };
    }
  };
}



/** WEBPACK FOOTER **
 ** ./src/app/components/loginForm/loginForm.directive.js
 **/